<template>
  <div
    v-if="
      props.paymentStatus === PaymentStatus.UNPAID ||
      (props.paymentStatus === PaymentStatus.PAID &&
        getEntrantPaymentSummary.length > 0) ||
      (props.paymentStatus === PaymentStatus.PAID &&
        getMealPaymentSummary.length > 0) ||
      (props.paymentStatus === PaymentStatus.PAID &&
        getEventPaymentSummary.length > 0) ||
      (props.paymentStatus === PaymentStatus.PAID &&
        getCarPaymentSummary.length > 0)
    "
    class="mb-3"
  >
    <div class="pca-dark-grey">{{ getTitle }}</div>

    <!-- Payment summary for: PRIMARY_ENTRANT, CO_ENTRANT, CHILD, GUEST -->
    <div
      v-if="
        props.formType === FormType.PRIMARY_ENTRANT ||
        props.formType === FormType.CO_ENTRANT ||
        props.formType === FormType.CHILD ||
        props.formType === FormType.GUEST
      "
    >
      <div
        v-for="entrantItem in getEntrantPaymentSummary"
        :key="entrantItem.id"
        class="d-flex justify-space-between pca-blue"
      >
        <span :class="entrantItem.id === 0 ? 'pca-dark-grey' : ''">
          {{ entrantItem.firstName }} {{ entrantItem.lastName }} 
          <span class="pca-dark-grey">{{getEntrantTypeByEntrantId(entrantItem.id)}}</span>

          <!-- Edit entrant button -->
          <v-tooltip location="top">
            <template v-slot:activator="{ props }">
              <v-btn
                v-bind="props"
                v-if="
                  !userDataStore.getIsEditingSelectedItem(entrantItem.id, route.params.id) &&
                  (
                    paymentStatus === PaymentStatus.UNPAID || 
                    entrantItem.formType === FormType.PRIMARY_ENTRANT ||
                    entrantItem.formType === FormType.GUEST
                  ) && entrantItem.id !== 0 &&
                  !appDataStore.getIsPastLockInDate
                "
                flat
                class="edit-btn mx-1"
                rounded="circle"
                size="extra-small"
                style="margin-top: 2px;"
                @click="
                  registrationCategory = RegistrationCategory.ENTRANT;
                  selectedEntrant = {
                    id: entrantItem.id,
                    firstName: entrantItem.firstName,
                    lastName: entrantItem.lastName,
                    mode: 'edit',
                    regCategory: RegistrationCategory.ENTRANT,
                  };
                  showEditConfirmationDialog = true;
                "
              >
                <v-icon color="pca-red" size="medium">mdi-pencil</v-icon>
              </v-btn>
            </template>
            <span>Edit Entrant Registration</span>
          </v-tooltip>
          
          <!-- Delete entrant button -->
          <v-tooltip location="top">
            <template v-slot:activator="{ props }">
              <v-btn
                v-bind="props"
                v-if="
                  !userDataStore.getIsEditingSelectedItem(entrantItem.id, route.params.id) &&
                  paymentStatus === PaymentStatus.UNPAID &&
                  entrantItem.id !== 0 &&
                  props.formType !== FormType.PRIMARY_ENTRANT &&
                  !appDataStore.getIsPastLockInDate
                "
                flat
                class="delete-btn"
                rounded="circle"
                size="extra-small"
                style="margin-top: 2px"
                @click="
                  registrationCategory = RegistrationCategory.ENTRANT;
                  selectedEntrant = {
                    id: entrantItem.id,
                    firstName: entrantItem.firstName,
                    lastName: entrantItem.lastName,
                    mode: 'delete',
                    regCategory: RegistrationCategory.ENTRANT,
                  };
                  showDeleteConfirmationDialog = true;
                "
              >
                <v-icon color="pca-red" size="medium">mdi-delete</v-icon>
              </v-btn>
            </template>
            <span>Delete Entrant Registration</span>
          </v-tooltip>
        </span>
        <span v-if="entrantItem.id !== 0">${{ entrantItem.price }}</span>
      </div>
    </div>

    <!-- Payment summary for MEAL -->
    <div v-if="props.formType === FormType.MEAL">
      <div
        v-for="(mealItem, index) in getMealPaymentSummary"
        :key="index"
        class="d-flex justify-space-between"
      >
        <div>
          <span v-if="mealItem.mealName === '- -'" class="pca-dark-grey">
            {{ mealItem.mealName }}
          </span>
          <span v-else class="pca-dark-grey">
            <span class="pca-blue">
              {{ mealItem.mealName.substring(0, 30)
              }}{{ mealItem.mealName.length > 30 ? '...' : '' }}
            </span>
            ({{ mealItem.entrantName }})
          </span>

          <!-- Edit meal button -->
          <v-tooltip location="top">
            <template v-slot:activator="{ props }">
              <v-btn
                v-bind="props"
                v-if="
                  !userDataStore.getIsEditingSelectedItem(mealItem.mealId, route.params.id) &&
                  paymentStatus === PaymentStatus.UNPAID &&
                  mealItem.mealName !== '- -' &&
                  !appDataStore.getIsPastLockInDate
                "
                flat
                class="edit-btn mr-1"
                rounded="circle"
                size="extra-small"
                @click="
                  registrationCategory = RegistrationCategory.MEAL;
                  selectedMeal = {
                    entrantId: mealItem.entrantId,
                    mealName: mealItem.mealName,
                    id: mealItem.mealId,
                    mode: 'edit',
                    regCategory: RegistrationCategory.MEAL,
                  };
                  showEditConfirmationDialog = true;
                "
              >
                <v-icon color="pca-red" size="medium">mdi-pencil</v-icon>
              </v-btn>
            </template>
            <span>Edit Meal Registration</span>
          </v-tooltip>

          <!-- Delete meal button -->
          <v-tooltip location="top">
            <template v-slot:activator="{ props }">
              <v-btn
                v-bind="props"
                v-if="
                  !userDataStore.getIsEditingSelectedItem(mealItem.mealId, route.params.id) &&
                  paymentStatus === PaymentStatus.UNPAID &&
                  mealItem.mealName !== '- -' &&
                  !appDataStore.getIsPastLockInDate
                "
                flat
                class="delete-btn"
                rounded="circle"
                size="extra-small"
                @click="
                  registrationCategory = RegistrationCategory.MEAL;
                  selectedMeal = {
                    entrantId: mealItem.entrantId,
                    mealName: mealItem.mealName,
                    id: mealItem.mealId,
                    mode: 'delete',
                    regCategory: RegistrationCategory.MEAL,
                  };
                  showDeleteConfirmationDialog = true;
                "
              >
                <v-icon color="pca-red" size="medium">mdi-delete</v-icon>
              </v-btn>
            </template>
            <span>Delete Meal Registration</span>
          </v-tooltip>
        </div>
        <div v-if="mealItem.mealName !== '- -'" class="pca-blue">
          ${{ mealItem.price }}
        </div>
      </div>
    </div>

    <!-- Payment summary for EVENTS -->
    <div v-if="props.formType === FormType.EVENT">
      <div
        v-for="(eventItem, index) in getEventPaymentSummary"
        :key="index"
        class="d-flex justify-space-between"
      >
        <div>
          <span v-if="eventItem.eventName === '- -'" class="pca-dark-grey">
            {{ eventItem.eventName }}
          </span>
          <span v-else class="pca-dark-grey">
            <span class="pca-blue">
              {{ eventItem.eventName.substring(0, 30) }}
              {{ eventItem.eventName.length > 30 ? '...' : '' }}
            </span>
            ({{ eventItem.entrantName }})
          </span>

          <!-- Edit event button -->
          <v-tooltip location="top">
            <template v-slot:activator="{ props }">
              <v-btn
                v-bind="props"
                v-if="
                  !userDataStore.getIsEditingSelectedItem(eventItem.eventId, route.params.id) &&
                  paymentStatus === PaymentStatus.UNPAID &&
                  eventItem.eventName !== '- -' &&
                  !appDataStore.getIsPastLockInDate &&
                  eventItem.price !== 'SOLD OUT'
                "
                flat
                class="edit-btn mr-1"
                rounded="circle"
                size="extra-small"
                @click="
                  registrationCategory = RegistrationCategory.EVENT;
                  selectedEvent = {
                    carId: eventItem.carId,
                    entrantId: eventItem.entrantId,
                    eventName: eventItem.eventName,
                    id: eventItem.eventId,
                    mode: 'edit',
                    regCategory: RegistrationCategory.EVENT,
                  };
                  showEditConfirmationDialog = true;
                "
              >
                <v-icon color="pca-red" size="medium">mdi-pencil</v-icon>
              </v-btn>
            </template>
            <span>Edit Event Registration</span>
          </v-tooltip>

          <!-- Delete event button -->
          <v-tooltip location="top">
            <template v-slot:activator="{ props }">
              <v-btn
                v-bind="props"
                v-if="
                  !userDataStore.getIsEditingSelectedItem(eventItem.eventId, route.params.id) &&
                  paymentStatus === PaymentStatus.UNPAID &&
                  eventItem.eventName !== '- -' &&
                  !appDataStore.getIsPastLockInDate
                "
                flat
                class="delete-btn"
                rounded="circle"
                size="extra-small"
                @click="
                  registrationCategory = RegistrationCategory.EVENT;
                  selectedEvent = {
                    carId: eventItem.carId,
                    entrantId: eventItem.entrantId,
                    eventName: eventItem.eventName,
                    id: eventItem.eventId,
                    mode: 'delete',
                    regCategory: RegistrationCategory.EVENT,
                  };
                  showDeleteConfirmationDialog = true;
                "
              >
                <v-icon color="pca-red" size="medium">mdi-delete</v-icon>
              </v-btn>
            </template>
            <span>Delete Event Registration</span>
          </v-tooltip>
        </div>
        <div v-if="eventItem.eventName !== '- -'" class="pca-blue">
          <div v-if="eventItem.price === 'SOLD OUT'" class="pca-red" style="font-weight: bold;">SOLD OUT</div>
          <div v-else>${{ eventItem.price }}</div>
        </div>
      </div>
    </div>

    <!-- Payment summary for CARS -->
    <div v-if="props.formType === FormType.CAR">
      <div
        v-for="(carItem, index) in getCarPaymentSummary"
        :key="index"
        class="d-flex justify-space-between"
      >
        <div v-if="carItem.modelName !== '- -'" class="pca-blue d-flex align-center">
          <div v-if="carItem.isPorsche">
            {{ carItem.year }} {{ carItem.modelName }} ({{ carItem.color }})
          </div>
          <div v-else>Non-Porsche Car {{ index + 1 }}</div>

          <!-- Edit car button -->
          <v-tooltip location="top">
            <template v-slot:activator="{ props }">
              <v-btn
                v-bind="props"
                v-if="
                  !userDataStore.getIsEditingSelectedItem(carItem.carId, route.params.id) &&
                  !appDataStore.getIsPastLockInDate
                "
                flat
                class="edit-btn mx-1"
                rounded="circle"
                size="extra-small"
                @click="
                  registrationCategory = RegistrationCategory.CAR;
                  selectedCar = {
                    color: carItem.color,
                    id: carItem.carId,
                    isPorsche: carItem.isPorsche,
                    mode: 'edit',
                    modelName: carItem.modelName,
                    regCategory: RegistrationCategory.CAR,
                    year: carItem.year,
                  };
                  showEditConfirmationDialog = true;
                "
              >
                <v-icon color="pca-red" size="medium">mdi-pencil</v-icon>
              </v-btn>
            </template>
            <span>Edit Car Registration</span>
          </v-tooltip>
          
          <!-- Delete car button -->
          <v-tooltip location="top">
            <template v-slot:activator="{ props }">
              <v-btn
                v-bind="props"
                v-if="
                  !userDataStore.getIsEditingSelectedItem(carItem.carId, route.params.id) &&
                  paymentStatus === PaymentStatus.UNPAID &&
                  carItem.modelName !== '- -' &&
                  !appDataStore.getIsPastLockInDate
                "
                flat
                class="delete-btn"
                rounded="circle"
                size="extra-small"
                @click="
                  registrationCategory = RegistrationCategory.CAR;
                  selectedCar = {
                    color: carItem.color,
                    id: carItem.carId,
                    isPorsche: carItem.isPorsche,
                    mode: 'delete',
                    modelName: carItem.modelName,
                    regCategory: RegistrationCategory.CAR,
                    year: carItem.year,
                  };
                  showDeleteConfirmationDialog = true;
                "
              >
                <v-icon color="pca-red" size="medium">mdi-delete</v-icon>
              </v-btn>
            </template>
            <span>Delete Car Registration</span>
          </v-tooltip>
        </div>
        <div v-else class="pca-dark-grey">
          {{ carItem.modelName }}
        </div>
        <div v-if="carItem.modelName !== '- -'" class="pca-blue">
          ${{ carItem.price }}
        </div>
      </div>
    </div>

    <!-- Edit registration confirmation modal -->
    <SimpleDialog
      v-if="showEditConfirmationDialog"
      :message="getEditRegConfirmationMessage"
      :showDialog="showEditConfirmationDialog"
      confirmLabel="Edit"
      confirmBtnColorClass="pca-red"
      declineLabel="Cancel"
      icon="mdi-alert"
      @submit="editRegItem"
      @update:showDialog="showEditConfirmationDialog = false"
    />

    <!-- Delete registration confirmation modal -->
    <SimpleDialog
      v-if="showDeleteConfirmationDialog"
      :message="getDeleteRegConfirmationMessage"
      :showDialog="showDeleteConfirmationDialog"
      confirmLabel="Delete"
      confirmBtnColorClass="pca-red"
      declineLabel="Cancel"
      icon="mdi-alert"
      @submit="deleteRegItem"
      @update:showDialog="showDeleteConfirmationDialog = false"
    />
  </div>
</template>

<script lang="ts">
// Components
import SimpleDialog from '@/components/shared/SimpleDialog.vue';

// Stores
import { useAppDataStore } from '@/stores/appDataStore';
import { useUserDataStore } from '@/stores/userDataStore';

// Types
import { AllRegisteredEntrantsResponse } from '@/types/apiResponses';
import { EntrantTypeOptions } from '@/types/formOptions';
import { RouteName } from '@/router/routes';
import {
  FormType,
  PaymentSummaryEntrantItem,
  PaymentSummaryEventItem,
  PaymentSummaryMealItem,
  PaymentSummaryCarItem,
} from '@/types/user';

// Utils
import {
  fetchDeleteCarRegistration,
  fetchDeleteEventRegistration,
  fetchDeleteMealRegistration,
  fetchDeleteUnpaidEntrant,
} from '@/api/apiCalls';
import {
  NotificationService,
  useNotification,
} from '@/utils/notificationService';
import { useRouter } from 'vue-router';

// Vue
import { computed, defineComponent, PropType, reactive, ref } from 'vue';
import { useRoute } from 'vue-router';

enum RegistrationCategory {
  ENTRANT = 'entrant',
  EVENT = 'event',
  MEAL = 'meal',
  CAR = 'car',
}

type SelectedEntrant = {
  firstName: string;
  id: number;
  lastName: string;
  mode: 'edit' | 'delete';
  regCategory: RegistrationCategory.ENTRANT;
};

type SelectedEvent = {
  carId: number;
  entrantId: number;
  eventName: string;
  id: number;
  mode: 'edit' | 'delete';
  regCategory: RegistrationCategory.EVENT;
};

type SelectedMeal = {
  entrantId: number;
  id: number;
  mealName: string;
  mode: 'edit' | 'delete';
  regCategory: RegistrationCategory.MEAL;
};

type SelectedCar = {
  color: string;
  id: number;
  isPorsche: boolean;
  mode: 'edit' | 'delete';
  modelName: string;
  regCategory: RegistrationCategory.CAR;
  year: number;
};

export enum PaymentStatus {
  PAID = 'paid',
  UNPAID = 'unpaid',
}

export default defineComponent({
  name: 'PaymentSummaryRowItemsByFormType',
  components: { SimpleDialog },
  props: {
    formType: {
      type: String as PropType<FormType>,
      required: true,
    },
    paymentStatus: {
      type: String as PropType<PaymentStatus>,
      required: true,
    },
    paymentSummary: {
      type: Array as PropType<
        (
          | PaymentSummaryEntrantItem
          | (Omit<PaymentSummaryEventItem, 'price'> & { price: number | 'SOLD OUT' })
          | PaymentSummaryMealItem
          | PaymentSummaryCarItem
        )[]
      >,
      required: true,
    },
  },

  setup(props) {
    // State

    const router = useRouter();
    const route = useRoute();
    const notification: NotificationService = useNotification();
    const showEditConfirmationDialog = ref<boolean>(false);
    const showDeleteConfirmationDialog = ref<boolean>(false);
    const selectedEntrant = ref<SelectedEntrant | null>(null);
    const selectedEvent = ref<SelectedEvent | null>(null);
    const selectedMeal = ref<SelectedMeal | null>(null);
    const selectedCar = ref<SelectedCar | null>(null);
    const appDataStore = reactive(useAppDataStore());
    const userDataStore = reactive(useUserDataStore());
    const registrationCategory = ref<RegistrationCategory | null>(null);

    // Computed

    const getEntrantTypeByEntrantId = (entrantId: number): string => {
      const entrant: AllRegisteredEntrantsResponse[number] | undefined = userDataStore.getAllRegisteredEntrants
        .find((entrant: AllRegisteredEntrantsResponse[number]) => entrant.ID === entrantId);
      if (entrant === undefined) {
        return '';
      }
      const entrantTypeOption: EntrantTypeOptions[0] | EntrantTypeOptions[1] | EntrantTypeOptions[2] | undefined = appDataStore.getEntrantTypeOptions
        .find((entrantType: EntrantTypeOptions[0] | EntrantTypeOptions[1] | EntrantTypeOptions[2]) => entrantType.value === entrant.ENTRANT_TYPE_ID);
      if (entrantTypeOption === undefined) {
        return '';
      }
      return `(${entrantTypeOption.title})`;
    };

    const getEditRegConfirmationMessage = computed((): string => {
      try {
        switch (registrationCategory.value) {
          case RegistrationCategory.ENTRANT: {
            if (selectedEntrant.value === null) {
              throw new Error(
                'getEditRegConfirmationMessage: selectedEntrant is null'
              );
            }
            return `
              Edit registration for <span class='pca-red'>${selectedEntrant.value.firstName} ${selectedEntrant.value.lastName}</span>?
            `;
          }
          case RegistrationCategory.EVENT: {
            if (selectedEvent.value === null) {
              throw new Error(
                'getEditRegConfirmationMessage: selectedEvent is null'
              );
            }
            const entrant = userDataStore.getPaymentSummary.event.find(
              (event: PaymentSummaryEventItem) =>
                event.eventId === selectedEvent.value?.id &&
                event.entrantId === selectedEvent.value?.entrantId
            );
            return `
              Edit registration for <span class='pca-red'>${selectedEvent.value.eventName} (${entrant?.entrantName})</span>?
            `;
          }
          case RegistrationCategory.MEAL: {
            if (selectedMeal.value === null) {
              throw new Error(
                'getEditRegConfirmationMessage: selectedMeal is null'
              );
            }
            return `
              Edit registration for <span class='pca-red'>${selectedMeal.value.mealName}</span>?
            `;
          }
          case RegistrationCategory.CAR: {
            if (selectedCar.value === null) {
              throw new Error(
                'getEditRegConfirmationMessage: selectedCar is null'
              );
            }
            return `
              Edit registration for <span class='pca-red'>${selectedCar.value.year} ${selectedCar.value.modelName ?? 'Vehicle'} (${selectedCar.value.color})</span>?
            `;
          }
          default: {
            throw new Error('getEditRegConfirmationMessage: Invalid formType');
          }
        }
      } catch (error) {
        notification.error({ error });
        return '';
      }
    });

    const getDeleteRegConfirmationMessage = computed((): string => {
      try {
        switch (registrationCategory.value) {
          case RegistrationCategory.ENTRANT: {
            if (selectedEntrant.value === null) {
              throw new Error(
                'getDeleteRegConfirmationMessage: selectedEntrant is null'
              );
            }
            if (userDataStore.getPrimaryEntrantDetails === null) {
              throw new Error('getDeleteRegConfirmationMessage: userDataStore.getPrimaryEntrantDetails is null');
            }
            return `
              Delete registration for <span class='pca-red'>${selectedEntrant.value.firstName} ${selectedEntrant.value.lastName}</span>?<br/>This action cannot be undone.
              ${selectedEntrant.value.id === userDataStore.getPrimaryEntrantDetails.ID ? '<br>This is the primary entrant.<br>Deleting this entrant will delete all other entrants in your party.' : ''}
            `;
          }
          case RegistrationCategory.EVENT: {
            if (selectedEvent.value === null) {
              throw new Error(
                'getDeleteRegConfirmationMessage: selectedEvent is null'
              );
            }
            return `Delete registration for <span class='pca-red'>${selectedEvent.value.eventName}</span>?<br/>This action cannot be undone.`;
          }
          case RegistrationCategory.MEAL: {
            if (selectedMeal.value === null) {
              throw new Error(
                'getDeleteRegConfirmationMessage: selectedMeal is null'
              );
            }
            return `Delete registration for <span class='pca-red'>${selectedMeal.value.mealName}</span>?<br/>This action cannot be undone.`;
          }
          case RegistrationCategory.CAR: {
            if (selectedCar.value === null) {
              throw new Error(
                'getDeleteRegConfirmationMessage: selectedCar is null'
              );
            }
            if (selectedCar.value.isPorsche) {
              return `Delete registration for <span class='pca-red'>${selectedCar.value.year} ${selectedCar.value.modelName} (${selectedCar.value.color})</span>?<br/>This action cannot be undone.`;
            } else {
              return 'Delete registration for <span class="pca-red">Non-Porsche Car</span>?<br/>This action cannot be undone.';
            }
          }
          default: {
            throw new Error(
              'getDeleteRegConfirmationMessage: Invalid formType'
            );
          }
        }
      } catch (error) {
        notification.error({ error });
        return '';
      }
    });

    const getEntrantPaymentSummary = computed(
      (): PaymentSummaryEntrantItem[] => {
        if (
          props.formType !== FormType.PRIMARY_ENTRANT &&
          props.formType !== FormType.CO_ENTRANT &&
          props.formType !== FormType.CHILD &&
          props.formType !== FormType.GUEST
        ) {
          return [];
        }
        if (props.paymentStatus === PaymentStatus.UNPAID) {
          const emptyRow: PaymentSummaryEntrantItem[] = [
            { id: 0, firstName: '- -', lastName: '', paid: false, price: 0, formType: props.formType },
          ];
          if (
            (props.paymentSummary as PaymentSummaryEntrantItem[]).every(
              (summaryItem: PaymentSummaryEntrantItem) => summaryItem.paid
            )
          ) {
            // Using a `0` id to flag FormTypes that have no registrations
            return emptyRow;
          } else {
            switch (props.formType) {
              // These were originally separated into diff switch cases, but now they're all the same
              // keeping the switch in case we need to do something different in the future
              case FormType.PRIMARY_ENTRANT:
              case FormType.CO_ENTRANT:
              case FormType.CHILD:
              case FormType.GUEST: {
                return (
                  props.paymentSummary as PaymentSummaryEntrantItem[]
                ).filter((summaryItem: PaymentSummaryEntrantItem) => {
                  return !summaryItem.paid;
                });
              }
              default: {
                throw new Error('getEntrantPaymentSummary: Invalid formType');
              }
            }
          }
        } else {
          // Paid entrants
          return (props.paymentSummary as PaymentSummaryEntrantItem[]).filter(
            (summaryItem: PaymentSummaryEntrantItem) => summaryItem.paid
          );
        }
      }
    );

    const getMealPaymentSummary = computed((): PaymentSummaryMealItem[] => {
      if (props.formType !== FormType.MEAL) {
        return [];
      }
      if (props.paymentStatus === PaymentStatus.UNPAID) {
        const emptyRow: PaymentSummaryMealItem[] = [
          {
            mealName: '- -',
            entrantName: '',
            paid: false,
            price: 0,
            entrantId: 0,
            mealId: 0,
            formType: FormType.MEAL,
          },
        ];
        if (
          (props.paymentSummary as PaymentSummaryMealItem[]).every(
            (summaryItem: PaymentSummaryMealItem) => summaryItem.paid
          )
        ) {
          // Using a `0` id to flag FormTypes that have no registrations
          return emptyRow;
        } else {
          return (props.paymentSummary as PaymentSummaryMealItem[]).filter(
            (summaryItem: PaymentSummaryMealItem) => !summaryItem.paid
          );
        }
      } else {
        // Paid entrants
        return (props.paymentSummary as PaymentSummaryMealItem[]).filter(
          (summaryItem: PaymentSummaryMealItem) => summaryItem.paid
        );
      }
    });

    const getEventPaymentSummary = computed((): (Omit<PaymentSummaryEventItem, 'price'> & { price: number | 'SOLD OUT' })[] => {
      if (props.formType !== FormType.EVENT) {
        return [];
      }
      if (props.paymentStatus === PaymentStatus.UNPAID) {
        const emptyRow: PaymentSummaryEventItem[] = [
          {
            eventName: '- -',
            entrantName: '',
            paid: false,
            price: 0,
            entrantId: 0,
            eventId: 0,
            carId: 0,
            formType: FormType.EVENT,
            seatsAvailable: 0,
          },
        ];
        if (
          (props.paymentSummary as PaymentSummaryEventItem[]).every(
            (summaryItem: PaymentSummaryEventItem) => summaryItem.paid
          )
        ) {
          // Using a `0` id to flag FormTypes that have no registrations
          return emptyRow;
        } else {
          return (props.paymentSummary as PaymentSummaryEventItem[]).filter(
            (summaryItem: PaymentSummaryEventItem) => !summaryItem.paid
          );
        }
      } else {
        // Paid entrants
        return (props.paymentSummary as PaymentSummaryEventItem[]).filter(
          (summaryItem: PaymentSummaryEventItem) => summaryItem.paid
        );
      }
    });

    const getCarPaymentSummary = computed((): PaymentSummaryCarItem[] => {
      if (props.formType !== FormType.CAR) {
        return [];
      }
      if (props.paymentStatus === PaymentStatus.UNPAID) {
        const emptyRow: PaymentSummaryCarItem[] = [
          {
            modelName: '- -',
            year: 0,
            color: '',
            carId: 0,
            paid: false,
            price: 0,
            isPorsche: false,
            legal: false,
            MEMBERCAR_ID: 0,
            formType: FormType.CAR,
          },
        ];
        if (
          (props.paymentSummary as PaymentSummaryCarItem[]).every(
            (summaryItem: PaymentSummaryCarItem) => summaryItem.paid
          )
        ) {
          // Using a `0` id to flag FormTypes that have no registrations
          return emptyRow;
        } else {
          return (props.paymentSummary as PaymentSummaryCarItem[]).filter(
            (summaryItem: PaymentSummaryCarItem) => !summaryItem.paid
          );
        }
      } else {
        // Paid cars
        return (props.paymentSummary as PaymentSummaryCarItem[]).filter(
          (summaryItem: PaymentSummaryCarItem) => summaryItem.paid
        );
      }
    });

    const getTitle = computed(() => {
      switch (props.formType) {
        case FormType.PRIMARY_ENTRANT:
          return 'Primary Entrant';
        case FormType.CO_ENTRANT:
          return 'Co-Entrant';
        case FormType.CHILD:
          return 'Children';
        case FormType.GUEST:
          return 'Guests';
        case FormType.EVENT:
          return 'Events + Extras';
        case FormType.MEAL:
          return 'Meals';
        case FormType.CAR:
          return 'Cars';
        default:
          throw new Error('getTitle: Invalid formType');
      }
    });

    // Methods

    const deleteRegItem = async (): Promise<void> => {
      try {
        let deletedItemName: string = '';

        if (registrationCategory.value === RegistrationCategory.ENTRANT) {
          if (selectedEntrant.value === null) {
            throw new Error('deleteRegItem: selectedEntrant is null');
          }
          if (userDataStore.getPrimaryEntrantDetails === null) {
            throw new Error('deleteRegItem: userDataStore.getPrimaryEntrantDetails is null');
          }
          deletedItemName = `${selectedEntrant.value.firstName} ${selectedEntrant.value.lastName}`;
          await fetchDeleteUnpaidEntrant({
            entrantId: selectedEntrant.value.id,
          });

          // If the primary entrant was deleted and we're not on the home page, SEND 'EM HOME!
          // This is for situations where the user deletes their primary entrant while in editing a form
          if (selectedEntrant.value.id === userDataStore.getPrimaryEntrantDetails.ID && route.name !== RouteName.HOME) {
            router.push(RouteName.HOME);
          }

        } else if (registrationCategory.value === RegistrationCategory.EVENT) {
          if (selectedEvent.value === null) {
            throw new Error('deleteRegItem: selectedEvent is null');
          }
          deletedItemName = selectedEvent.value.eventName;
          await fetchDeleteEventRegistration(
            selectedEvent.value.id,
            selectedEvent.value.entrantId,
            selectedEvent.value.carId
          );
        } else if (registrationCategory.value === RegistrationCategory.MEAL) {
          if (selectedMeal.value === null) {
            throw new Error('deleteRegItem: selectedMeal is null');
          }
          deletedItemName = selectedMeal.value.mealName;
          await fetchDeleteMealRegistration(
            selectedMeal.value.id,
            selectedMeal.value.entrantId
          );
        } else if (registrationCategory.value === RegistrationCategory.CAR) {
          if (selectedCar.value === null) {
            throw new Error('deleteRegItem: selectedCar is null');
          }
          deletedItemName = `${selectedCar.value.year} ${selectedCar.value.modelName} (${selectedCar.value.color})`;
          await fetchDeleteCarRegistration(selectedCar.value.id);
        }

        // Update registered entrants and payment summary
        await userDataStore.requestAllRegisteredEntrantsAndPaymentSummary();

        
        notification.notify({
          message: `Registration for ${deletedItemName} has been deleted`,
          color: 'green',
          timeout: 3000,
        });
      } catch (error) {
        notification.error({ error });
      } finally {
        selectedEntrant.value = null;
      }
    };

    const editRegItem = async (): Promise<void> => {
      try {
        // PRIMARY_ENTRANT, CO_ENTRANT, CHILD, GUEST
        if (registrationCategory.value === RegistrationCategory.ENTRANT) {
          if (selectedEntrant.value === null) {
            throw new Error('editRegItem: selectedEntrant is null');
          }
          switch (props.formType) {
            case FormType.PRIMARY_ENTRANT: {
              router.push({
                name: RouteName.REGISTER_PRIMARY_ENTRANT,
                params: { id: selectedEntrant.value.id },
              });
              break;
            }
            case FormType.CO_ENTRANT: {
              router.push({
                name: RouteName.REGISTER_CO_ENTRANT,
                params: { id: selectedEntrant.value.id },
              });
              break;
            }
            case FormType.CHILD: {
              router.push({
                name: RouteName.REGISTER_CHILD,
                params: { id: selectedEntrant.value.id },
              });
              break;
            }
            case FormType.GUEST: {
              router.push({
                name: RouteName.REGISTER_GUEST,
                params: { id: selectedEntrant.value.id },
              });
              break;
            }
            default: {
              throw new Error('editRegItem: Invalid formType');
            }
          }
          // EVENT
        } else if (registrationCategory.value === RegistrationCategory.EVENT) {
          if (selectedEvent.value === null) {
            throw new Error('editRegItem: selectedEvent is null');
          }
          switch (selectedEvent.value.id) {
            case 7:
            case 121: {
              // AutoX event
              router.push({
                name: RouteName.REGISTER_AUTOX_EVENT,
                params: {
                  eventId: selectedEvent.value.id,
                  entrantId: selectedEvent.value.entrantId,
                },
              });
              break;
            }
            case 199:
            case 235: {
              // Sim Racing events (235 is tryouts)
              router.push({
                name: RouteName.REGISTER_SIM_RACING_EVENT,
                params: {
                  eventId: selectedEvent.value.id,
                  entrantId: selectedEvent.value.entrantId,
                },
              });
              break;
            }
            case 3: {
              // Concours event
              router.push({
                name: RouteName.REGISTER_CONCOURS_EVENT,
                params: {
                  eventId: selectedEvent.value.id,
                  entrantId: selectedEvent.value.entrantId,
                },
              });
              break;
            }
            default: {
              // Standard events
              router.push({
                name: RouteName.REGISTER_STANDARD_EVENT,
                params: {
                  eventId: selectedEvent.value.id,
                  entrantId: selectedEvent.value.entrantId,
                },
              });
              break;
            }
          }
        } else if (registrationCategory.value === RegistrationCategory.MEAL) {
          if (selectedMeal.value === null) {
            throw new Error('editRegItem: selectedMeal is null');
          }
          router.push({
            name: RouteName.REGISTER_MEAL,
            params: {
              mealId: selectedMeal.value.id,
              entrantId: selectedMeal.value.entrantId,
            },
          });
        } else if (registrationCategory.value === RegistrationCategory.CAR) {
          if (selectedCar.value === null) {
            throw new Error('editRegItem: selectedCar is null');
          }
          router.push({
            name: RouteName.REGISTER_CAR,
            params: { id: selectedCar.value.id },
          });
        }
      } catch (error) {
        notification.error({ error });
      } finally {
        selectedEntrant.value = null;
        selectedEvent.value = null;
        selectedMeal.value = null;
        selectedCar.value = null;
      }
    };

    return {
      FormType,
      PaymentStatus,
      RegistrationCategory,
      appDataStore,
      deleteRegItem,
      editRegItem,
      getCarPaymentSummary,
      getDeleteRegConfirmationMessage,
      getEditRegConfirmationMessage,
      getEntrantPaymentSummary,
      getEntrantTypeByEntrantId,
      getEventPaymentSummary,
      getMealPaymentSummary,
      getTitle,
      props,
      registrationCategory,
      route,
      RouteName,
      router,
      selectedCar,
      selectedEntrant,
      selectedEvent,
      selectedMeal,
      showDeleteConfirmationDialog,
      showEditConfirmationDialog,
      userDataStore,
    };
  },
});
</script>

<style scoped lang="scss">
.v-card {
  border-radius: 20px !important;
  margin-bottom: 35px !important;
  margin-top: 35px;
  max-width: 600px;
  padding: 25px !important;
  width: 100%;
}

.summary-content {
  background-color: $pca-light-grey;
  border-radius: 8px;
  font-size: 14px;
  font-weight: 600;
}

.edit-btn,
.delete-btn {
  background-color: transparent;
  width: 18px !important;
  margin: 0px 0px 4px 1px;
}

.edit-btn {
  border: 1px solid $pca-red;
  color: $pca-red;
}

.delete-btn {
  border: 1px solid $pca-red;
  color: $pca-red;
}
</style>
